
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Trash2, Recycle, TruckIcon, Factory, 
  ReceiptText, Leaf, Package, AlertTriangle
} from "lucide-react";

interface WasteMaterial {
  type: string;
  description: string;
  solutions: string[];
  environmentalBenefit: string;
}

interface WasteSolutionCardProps {
  wasteMaterial: WasteMaterial;
}

const WasteSolutionCard: React.FC<WasteSolutionCardProps> = ({ wasteMaterial }) => {
  const getIcon = (name: string) => {
    switch (name.toLowerCase()) {
      case 'trash':
      case 'déchets':
        return <Trash2 className="h-6 w-6 text-fabre-green" />;
      case 'recycle':
      case 'recyclage':
        return <Recycle className="h-6 w-6 text-fabre-green" />;
      case 'transport':
      case 'collecte':
        return <TruckIcon className="h-6 w-6 text-fabre-green" />;
      case 'usine':
      case 'traitement':
        return <Factory className="h-6 w-6 text-fabre-green" />;
      case 'document':
      case 'traçabilité':
        return <ReceiptText className="h-6 w-6 text-fabre-green" />;
      case 'écologie':
      case 'environnement':
        return <Leaf className="h-6 w-6 text-fabre-green" />;
      case 'emballage':
      case 'contenants':
        return <Package className="h-6 w-6 text-fabre-green" />;
      case 'danger':
      case 'dangereux':
        return <AlertTriangle className="h-6 w-6 text-fabre-green" />;
      default:
        return <Recycle className="h-6 w-6 text-fabre-green" />;
    }
  };

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent className="p-6">
        <h3 className="text-xl font-heading font-bold mb-3 text-fabre-gray">
          {wasteMaterial.type}
        </h3>
        
        <p className="text-gray-600 mb-6">
          {wasteMaterial.description}
        </p>
        
        <div className="space-y-4">
          {wasteMaterial.solutions.map((solution, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="mt-1 flex-shrink-0">
                {getIcon(solution)}
              </div>
              <div>
                <h4 className="font-semibold text-fabre-darkgreen">
                  {solution}
                </h4>
                <p className="text-sm text-gray-600">
                  Solution professionnelle adaptée à vos besoins
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 p-4 bg-fabre-lightgreen rounded-lg">
          <div className="flex items-start gap-2">
            <Leaf className="h-5 w-5 text-fabre-green mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="font-semibold text-fabre-darkgreen text-sm">
                Bénéfice environnemental
              </h4>
              <p className="text-sm text-gray-700">
                {wasteMaterial.environmentalBenefit}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WasteSolutionCard;
